import React, { useState, useEffect, useRef } from 'react';
import {
    List, Datagrid, TextField, FunctionField, SimpleList
} from 'react-admin';
import {
    useMediaQuery, makeStyles, withStyles, Button, Dialog, DialogContent, Switch, DialogActions
} from '@material-ui/core';
import { customTheme } from "./customTheme";
import CustomSearch from './components/CustomSearch';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import moment from 'moment';
import ScrollableTable from './components/ScrollableTable';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { translate, crudUpdate } from 'ra-core';
import CustomFilter from './components/CustomFilter';
import CustomExportButton from './components/CustomExportButton';
import notify from './components/CustomUseNotify';
import config from "./config.json";
import queryString from 'query-string';
import { saveTokens } from './utils/saveTokens';
import CustomDateTimePicker from './components/CustomDateTimePickerV2';


const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
});

const CATEGORY = "PURCHASED SECTION"

export const PurchasedFastags = props => {
    const eventTracker = UseAnalyticsEvent();
    const classes = useStyles();
    const location = useLocation();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const listDataRef = useRef();

    const [isAdmin] = useState(sessionStorage.getItem("role") === "admin");
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["Name", "Mobile"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Name");
    const [settingFilterFormat, setSettingFilterFormat] = useState({})

    const [startDateTime, setStartDateTime] = useState(null);
    const [endDateTime, setEndDateTime] = useState(null);
    const [startDateTimeFilter, setStartDateTimeFilter] = useState(null);
    const [endDateTimeFilter, setEndDateTimeFilter] = useState(null);
    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
	const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");

	const renderTime = time => {
		const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if(use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY HH:mm${secondsFormat}`)
        return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY hh:mm${secondsFormat} A`)
	};

    const filter = { ...settingFilterFormat, start_time: startDateTimeFilter ? moment(startDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss")  :  "", end_time: endDateTimeFilter ? moment(endDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "", search: { value: search ? search : "", type: searchTypes ? searchTypes : "" } };


    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)
    let filterTypesInitState = [
        {
            filterType: "Order Status",
            dataList: [{ name: "Delivered", id: 1 }, { name: "Pending", id: 2 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
    ]

    const setTimeFilters = () => {
        setStartDateTimeFilter(startDateTime);
        setEndDateTimeFilter(endDateTime);
    };

    const getExportFile = (fileType) => {
        const {current : {total, currentSort, filterValues}} = listDataRef
        const params = {
            filter: JSON.stringify({ ...filter, ...filterValues }),
            sort: JSON.stringify([currentSort.field, currentSort.order]),
            page: 1,
            perPage: total,
            user_id: sessionStorage.getItem("user_id")
        };
        fetch(`${config.HOST_NAME}/crm/v3/purchasedFastags?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Accept': `application/${fileType}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.blob()
            })
            .then(blob => {
                const url = URL.createObjectURL(blob);
                const tempLinkElement = document.createElement('a');
                tempLinkElement.href = url;
                tempLinkElement.setAttribute('download', `Purchased Fastag Data.${fileType}`);
                tempLinkElement.click();
            })
            .catch(error => {
                notify('Error Exporting Data', 'warning');
            });
    };

    const getExcelFile = () => {
        getExportFile("xlsx");
    };

    useEffect(() => {
        eventTracker(CATEGORY, "PURCHASED FASTAG DATA LIST")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        let values = {}
        // Add more types based on the filters
        if (filterListValue) {
            for (let val in filterListValue) {
                if (filterListValue[val].filterType === "Order Status") {
                    values = { ...values, order_status: filterListValue[val].value ? filterListValue[val].value : undefined }
                }
            }
            setSettingFilterFormat(values)
        }
        if (filterListValue === null) {
            setSettingFilterFormat({})
        }
    }, [filterListValue]) // eslint-disable-line react-hooks/exhaustive-deps

    return <div className={classes.list}>
        <div className='customStyleForDataSearchDiv'>
            <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
            <CustomDateTimePicker startDateTime={startDateTime} setStartDateTime={setStartDateTime} endDateTime={endDateTime} setEndDateTime={setEndDateTime} onChange={setTimeFilters} />
            <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} />
            <CustomExportButton getCSV={getExcelFile} disabled={listDataRef.current && listDataRef.current.total === 0} />
        </div>

        <List
            {...props}
            style={{marginTop: 20}}
            title="Purchased Fastag"
            bulkActionButtons={false}
            exporter={false}
            filter={filter}
            empty={false}
            pagination={<CustomPagination setListData={(listData) => {listDataRef.current = listData}} />}
            actions={false}
        >
            {
                isSmallDevice ?
                    <SimpleList
                        primaryText={record => record.full_name}
                        secondaryText={record => (<div>
                            {record.mobile && <div><span style={{ color: "#5a5a5a" }}>Mobile: </span>{record.mobile}</div>}
                            {record.amount && <div><span style={{ color: "#5a5a5a" }}>Amount: </span>{record.amount}</div>}
                            {record.tags_quantity && <div><span style={{ color: "#5a5a5a" }}>Tags Quantity: </span>{record.tags_quantity}</div>}
                            {record.created_on && <div><span style={{ color: "#5a5a5a" }}>Purchased On: </span>{renderTime(record["created_on"])}</div>}
                            <div><span style={{ color: "#5a5a5a" }}>Order Status: </span>{record.delivered ? "Delivered" : "Pending"}</div>
                            {record.delivered_on && <div><span style={{ color: "#5a5a5a" }}>Delivered On: </span>{renderTime(record["delivered_on"])}</div>}
                            {record.address_line_1 && <div><span style={{ color: "#5a5a5a" }}>Address Line 2: </span>{record.address_line_1}</div>}
                            {record.address_line_2 && <div><span style={{ color: "#5a5a5a" }}>Address Line 2: </span>{record.address_line_2}</div>}
                            {record.pincode && <div><span style={{ color: "#5a5a5a" }}>Pincode: </span>{record.pincode}</div>}
                            {record.city && <div><span style={{ color: "#5a5a5a" }}>City: </span>{record.city}</div>}
                            {record.state && <div><span style={{ color: "#5a5a5a" }}>State: </span>{record.state}</div>}
                        </div>)}
                        onContextMenu={event => event.preventDefault()}
                        rightIcon={(record) => isAdmin &&
                            <FunctionField label={false} source='delivered' render={record => record && <CustomApprovalButton record={record} label="Delivered" source="delivered" />} />}
                        linkType={false}
                        rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                    />
                    :
                    <Datagrid component={ScrollableTable}>
                        {isAdmin &&
                            <FunctionField label={false} source='delivered' render={record => record && <CustomApprovalButton record={record} label="Delivered" source="delivered" />} />
                        }
                        <TextField source='full_name' label="Name" />
                        <TextField source='mobile' label="Mobile" />
                        <TextField source='tags_quantity' label="Tags Quantity" />
                        <FunctionField source='amount' label="Amount" render={record => record && <span style={{ fontWeight: "bold" }}>₹ {record.amount}</span>} />
                        <FunctionField source="created_on" label="Purchased On" render={record => renderTime(record["created_on"])} />
                        <FunctionField source='delivered' label="Order Status" render={record => record && <span style={{ fontWeight: "bold", color: record.delivered ? '#18cc69' : '#de575e' }}>{record.delivered ? 'Delivered' : "Pending"}</span>} />
                        <FunctionField source="delivered_on" label="Delivered On" render={record => record.delivered === 1 ? renderTime(record["delivered_on"]) : '-'} />
                        <TextField source='address_line_1' label="Address Line 1" />
                        <TextField source='address_line_2' label="Address Line 2" />
                        <TextField source='pincode' label="Pincode" />
                        <TextField source='city' label="City" />
                        <TextField source='state' label="State" />


                    </Datagrid>
            }
        </List>
    </div>
};

function ApprovalButton(props) {
    const { record, source } = props;
    const isSmallDevice = useMediaQuery(theme => theme.breakpoints.down("xs"));

    const [dialogVisible, setDialogVisible] = React.useState(false);

    const openDialog = () => {
        setDialogVisible(true);
    };

    const closeDialog = () => {
        setDialogVisible(false);
    };

    const handleUpdate = (event) => {
        event.preventDefault();
        closeDialog();
        const { dispatchCrudUpdate, basePath } = props;
        const data = {
            ...record,
            delivered: !record.delivered === false ? 0 : 1,
        };
        dispatchCrudUpdate('purchasedFastags', record.id, data, record, basePath, "/purchasedFastags");
    };

    return (
        <div style={{ textAlign: isSmallDevice ? "left" : "center", display: isSmallDevice ? "flex" : "block", alignItems: "center", flex: 1 }}>
            {/* {isSmallDevice && <Typography style={{ fontSize: 15 }}>Status:</Typography>} */}
            <AntSwitch checked={Boolean(record.delivered)} onChange={openDialog} />

            <Dialog fullWidth open={dialogVisible} onClose={closeDialog}>
                {record[source] ? <DialogContent>Are you sure you want to undo the delivery status?</DialogContent> : <DialogContent>Are you sure this FASTag has been delivered?</DialogContent>}

                <DialogActions>
                    <Button color="default" onClick={closeDialog}>No</Button>
                    <Button color="secondary" onClick={handleUpdate}>Yes</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
ApprovalButton.defaultProps = {
    redirect: 'list',
    undoable: false
};
const CustomApprovalButton = compose(
    connect(
        null,
        { dispatchCrudUpdate: crudUpdate }
    ),
    translate
)(ApprovalButton);

const AntSwitch = withStyles((theme) => ({
    root: {
        width: 29,
        height: 16,
        padding: 0,
        display: 'flex',
    },
    switchBase: {
        padding: 2,
        color: theme.palette.grey[500],
        '&$checked': {
            transform: 'translateX(12px)',
            color: theme.palette.common.white,
            '& + $track': {
                opacity: 1,
                backgroundColor: theme.palette.primary.main,
                borderColor: theme.palette.primary.main,
            },
        },
    },
    thumb: {
        width: 12,
        height: 12,
        boxShadow: 'none',
    },
    track: {
        border: `1px solid ${theme.palette.grey[500]}`,
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: theme.palette.common.white,
        height: "auto",
        paddingTop: 2,
        paddingBottom: 2
    },
    checked: {},
}))(Switch);